export default "__VITE_ASSET__Db1E1n2u__"